export class HangingProtocolListDetailsModel {
  id: string;
  description: string;
  criteria: string;
  version: string;
}
